import axios from "axios";

const API_URL = "http://210.3.12.74:9100/api/auth/";
//const API_URL = "http://34.92.77.213:8080/api/auth/";
const register = (username, email, password) => {
  return axios.post(API_URL + "signup", {
    username,
    email,
    password,
  });
};

const adminregister = (username, email, password, roles) => {
  return axios.post(API_URL + "signup", {
    username,
    email,
    password,
    roles
  });
};

const login = (username, password) => {
  let headers = new Headers();

    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    //headers.append('Authorization', 'Basic ' + base64.encode(username + ":" +  password));
    //headers.append('Origin','http://localhost:8080');
  return axios
    .post(API_URL + "signin", {
      username,
      password,
    },
    {
      headers: headers
    })
    .then((response) => {
      if (response.data.accessToken) {
        localStorage.setItem("user", JSON.stringify(response.data));
      }

      return response.data;
    });
};

const changePassword = (username, oldPassword, newPassword) => {
  let headers = new Headers();

    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    //headers.append('Authorization', 'Basic ' + base64.encode(username + ":" +  password));
    //headers.append('Origin','http://localhost:8080');
  return axios
    .post(API_URL + "changepassword", {
      username,
      oldPassword,
      newPassword
    },
    {
      headers: headers
    })
    .then((response) => {
      if (response.data.accessToken) {
        // localStorage.setItem("user", JSON.stringify(response.data));
      }

      return response.data;
    });
};

const logout = () => {
  localStorage.removeItem("user");
};

const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem("user"));
};


export default {
  register,
  adminregister,
  login,
  changePassword,
  logout,
  getCurrentUser
 
};
